import { gql } from "@apollo/client";

export const ALL_POSTS = gql`
	query repoQuery($first: Int, $tag: String, $after: String, $categoryName: String) {
		posts(first: $first, after: $after, where: { tag: $tag, categoryName: $categoryName }) {
			pageInfo {
				hasNextPage
				hasPreviousPage
				startCursor
				endCursor
			}
			edges {
				cursor
				node {
					id
					title
					excerpt
					slug
					date
					categories(first: 1) {
						nodes {
							id
							name
						}
					}
					featuredImage {
						node {
							sourceUrl
							altText
							srcSet
						}
					}
				}
			}
		}
	}
`;
